module.exports = __webpack_public_path__ + "static/media/lineActiveh.0c27eace.svg";